import cn from 'classnames';
import { Field, useFormikContext } from 'formik';
import { useState, useEffect, useMemo } from 'react';

import FormField from 'components/common/FormField';
import Subheading from 'components/common/Subheading';
import Text from 'components/common/Text';
import SmsLegalText from 'components/signUpFunnel/shared/SmsLegalText';

const IntroSmsOptIn = ({ isTempo }) => {
  const { handleChange, values, touched, errors, handleBlur } = useFormikContext();
  const [displayPhone, setDisplayPhone] = useState(false);

  const isPhoneNumberValid = useMemo(() => !errors.phoneNumber, [errors.phoneNumber]);

  useEffect(() => {
    setDisplayPhone(values.introSmsOptIn);
  }, [values.introSmsOptIn]);

  return (
    <>
      <Subheading
        className={cn('text-secondary mb-2 mt-4 bp1:mt-2', {
          'text-charcoal-70': !isPhoneNumberValid,
        })}
        brandStylesOverrides={isTempo ? 'h5' : 'h6'}
      >
        Would you like to stay updated via text?
      </Subheading>
      <label htmlFor="introSmsOptIn" className="block">
        <div className="flex items-start">
          <Field
            type="checkbox"
            name="introSmsOptIn"
            id="introSmsOptIn"
            onChange={async event => {
              handleChange(event);
            }}
            className="mt-1"
            disabled={!isPhoneNumberValid}
          />
          <Text
            htmlElement="span"
            className={cn('ml-2', {
              'text-charcoal-70': !isPhoneNumberValid,
            })}
          >
            I want to receive texts about offers, menus, and news from
            {isTempo ? ' Tempo' : ' Home Chef'}.
          </Text>
        </div>
      </label>
      {displayPhone && (
        <>
          <FormField
            label="Phone Number"
            labelClass="sr-only"
            labelBrandStylesOverrides="textMd"
            name="introSmsPhoneNumber"
            type="tel"
            placeholder="Phone Number"
            inputClass="mb-2"
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.introSmsPhoneNumber && errors.introSmsPhoneNumber}
          />
          <SmsLegalText isPhoneNumberValid={isPhoneNumberValid} />
        </>
      )}
    </>
  );
};

IntroSmsOptIn.propTypes = {
  isTempo: PropTypes.bool,
};

export default IntroSmsOptIn;
